<div class="file-explorer-toolbar">
  <div class="wrapper">
    <!-- Refresh Button (saving for if we want to use it later) -->
    <!-- <button class="tool-button"><span><i class="fas fa-sync-alt"></i>Refresh</span></button> -->
    <div class='title'>File Explorer</div>

  </div>
  <div class="wrapper">
    <div class="dropdown">
      <button class="btn dropdown-toggle tool-button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span><i class="fas fa-sort-amount-down"></i>Sort by </span>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        @for (method of sortMethods; track method) {
          <button class="dropdown-item" [class.current]="method === currentSortMethod" (click)="changeSortingMethod(method)">
            @if (method === currentSortMethod) {
              <i class="fas fa-check"></i>
            }
            {{ method.replace('_', ' ') | titlecase }}
          </button>
        }
        <div class='dropdown-divider'></div>
        @for (direction of sortDirections; track direction) {
          <button class="dropdown-item" [class.current]="direction === currentSortDirection" (click)="changeSortingDirection(direction)">
            @if (direction === currentSortDirection) {
              <i class="fas fa-check"></i>
            }
            {{ direction === 'ASC' ? 'Ascending' : 'Descending' }}
          </button>
        }
      </div>
    </div>
    <div class="toolbar-right">
      <button
        title="unselect all"
        class="btn btn-sm btn-secondary tag-button"
        [disabled]="selectedCount === 0"
        [class.disabled]="selectedCount === 0"
        (click)="onTagPress()"
        >
        Tag Items <i [style.margin-left.px]="8" class="fas fa-tag"></i>
      </button>
      <button class="btn btn-sm btn-outline-success download-button"
        [disabled]="selectedCount === 0"
        [class.disabled]="selectedCount === 0"
        title="Download Records"
        (click)="downloadFiles()"
        >
        <i class="fa fa-fw fa-download"></i>
      </button>
    </div>
  </div>
</div>